<template>
    <div class="col-12">
        <div class="row text-center ml-5">
            <h3 class="ui inverted purple text"><strong>Signature</strong></h3>
            <p class="text-muted fw-light mt-4">
                Insert your signature in the box below.
            </p>
        </div>

        <div class="row d-flex justify-content-center align-items-center mt-5">
            <div class="col-11 col-lg-9">
                <div class="row ml-5">
                    <div class="container">
                        <VueSignaturePad
                            id="signature"
                            width="100%"
                            height="300px"
                            ref="signaturePad"
                        />
                    </div>
                </div>

                <div class="mt-5">
                    <button
                        class="ui button purple fluid mt-4"
                        @click="save()"
                        :disabled="!isSignatureEmpty"
                        type="submit"
                    >
                        Save
                    </button>
                    <button class="ui button red fluid mt-4 mb-4" @click="clear()">
                        Clear Signature
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import baseMethods from "@/utils/baseMethods";
import { URLS } from "@/utils/constants";
import { utils } from "@/utils/utils";
export default {
    name: "CustomerSignature",
    data() {
        return {
            count: 0,
            isSignatureEmpty: true,
            signatureSubmitionRequest: {
                mobileNumber: localStorage.getItem("phone-number"),
                signature: "",
            },
        };
    },
    mounted() {
        this.getSession();
    },
    methods: {
        undo() {
            this.$refs.signaturePad.undoSignature();
        },
        clear() {
            this.$refs.signaturePad.clearSignature();
        },
        getSession() {
            localStorage.setItem("access_token", this.$route.params.sessionUid);
            
                    if (
                        this.$route.params.sessionUid !== null &&
                        typeof this.$route.params.sessionUid !== "undefined"
                    ) {

                     this.getNoAuthUssd(URLS.getSession.replace("{uid}", this.$route.params.sessionUid), true)
                                    .then((res) => {
                                        localStorage.setItem("phone-number", res.body.phone);
                                        this.signatureSubmitionRequest.mobileNumber = res.body.phone;
                                        localStorage.setItem("access_token", res.body.additionalData.accessToken);
                                    })
                                    .catch((e) => {
                                        utils.logger(e);
                                        window.Swal.fire({
                                            title: "Session Expired",
                                            text: `Failed to get your details. Please try again`,
                                            icon: "error",
                                            showConfirmButton: true,
                                            confirmButtonColor: "#9627ba",
                                        }).then(() => {});
                                        
                                        //this.$router.push("/account-opening/login");
                                    });
                    }else{
                        window.Swal.fire({
                            title: "Session Expired",
                            text: `Your whatsapp session has expired. Please go back to whatsapp login and try again`,
                            icon: "error",
                            showConfirmButton: true,
                            confirmButtonColor: "#9627ba",
                        }).then(() => {});
                    }
                },
        save() {
            const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
            this.isSignatureEmpty = isEmpty;
            if (!isEmpty) {
                localStorage.setItem("signature", data);
                this.signatureSubmitionRequest.signature = data;
                this.postAuthUssd(
                    URLS.uploadSignature,
                    this.signatureSubmitionRequest,
                    "Submit  Signature",
                    null,
                    true
                ).then((res) => {
                    if (!res) return;
                    if (res.errors) return (this.errors = res.errors);
                    if (res.body.status === "COMPLETE") {
                        window.Swal.fire({
                            title: "Success",
                            text: `Your signature has been submitted successfully. Please return to WhatsApp to proceed with the conversation`,
                            icon: "success",
                            showConfirmButton: true,
                            confirmButtonColor: "#9627ba",
                        }).then(() => {});
                        this.$router.push("/account-opening/channels/submition");
                    } else {
                        window.Swal.fire({
                            title: "Session Expired",
                            text: `Your whatsapp session has expired. Please go back to whatsapp login and try again`,
                            icon: "error",
                            showConfirmButton: true,
                            confirmButtonColor: "#9627ba",
                        }).then(() => {});
                        //   this.$router.push("/account-opening/isave-failed");
                    }
                });
            }
        },
        submitForm() {},
        ...baseMethods,
    },
};
</script>
